var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 13.3334L14.9993 13.3334C15.4414 13.3334 15.8653 13.1578 16.1779 12.8452C16.4904 12.5327 16.666 12.1087 16.666 11.6667L16.666 5.00004C16.666 4.55801 16.4904 4.13409 16.1779 3.82153C15.8653 3.50897 15.4414 3.33337 14.9993 3.33337L8.33268 3.33337C7.89066 3.33337 7.46673 3.50897 7.15417 3.82153C6.84161 4.13409 6.66602 4.55801 6.66602 5.00004L6.66602 6.66671M11.666 6.66671C12.108 6.66671 12.532 6.8423 12.8445 7.15486C13.1571 7.46742 13.3327 7.89135 13.3327 8.33337L13.3327 15C13.3327 15.4421 13.1571 15.866 12.8445 16.1786C12.532 16.4911 12.108 16.6667 11.666 16.6667L4.99935 16.6667C4.55732 16.6667 4.1334 16.4911 3.82084 16.1786C3.50828 15.866 3.33268 15.4421 3.33268 15L3.33268 8.33337C3.33268 7.89135 3.50828 7.46742 3.82084 7.15486C4.1334 6.8423 4.55732 6.66671 4.99935 6.66671L11.666 6.66671Z",
    stroke: "#5A5A5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e5065cdec11723880d030a504653f693.svg";
export { ForwardRef as ReactComponent };